// extracted by mini-css-extract-plugin
export default {"Wrapper":"Login_Wrapper__WBFev","Left":"Login_Left__zLxRi","Right":"Login_Right__SwXiI","Img_Pane":"Login_Img_Pane__iPknd","Login":"Login_Login__T5KtO"};